import { changeLanguage } from '@data/other/i18n';
import { createColorScale, createContrastColorScale, } from '@theme/foundations/colors';
/**
 * Global configuration object for the Immersive Experience web component library
 */
class GlobalConfig {
    constructor() {
        Object.defineProperty(this, "colors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, color) => (this.colors[key] = color)
        });
        Object.defineProperty(this, "resetColors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.colors = {};
            }
        });
        Object.defineProperty(this, "setLang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang) => {
                this.lang = lang;
                changeLanguage(lang);
            }
        });
    }
    get themeColors() {
        return Object.keys(this.colors).reduce((acc, key) => {
            const colorScale = createColorScale(this.colors[key]);
            acc[key] = colorScale;
            if (key === 'primary') {
                acc['primaryContrast'] = createContrastColorScale(colorScale[600]);
            }
            return acc;
        }, {});
    }
}
export const globalConfig = new GlobalConfig();
